module.exports = __webpack_public_path__ + "static/img/Kyle.Hardingham.2b5ba42.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Kyle.Hardingham.jpg
// module id = BpjY
// module chunks = 0